export const failureHash = {
    BILLING_POLICY_INCOMPATIBLE: "API__EP__BILLING__BILLING_POLICY_INCOMPATIBLE",
    BILL_PRODUCT_FORBIDDEN: "API__EP__BILLING__BILL_PRODUCT_FORBIDDEN",
    BILL_PRODUCT_PRICE_ZERO: "API__EP__BILLING__BILL_PRODUCT_PRICE_ZERO",
    BILL_PRODUCT_SALE_FROZEN: "API__EP__BILLING__BILL_PRODUCT_SALE_FROZEN",
    PLAN_ACTIVE_INCOMPATIBLE: "API__EP__BILLING__PLAN_ACTIVE_INCOMPATIBLE",
    PROMOCODE_NOT_FOUND: "API__EP__BILLING__PROMOCODE_NOT_FOUND",
    PROMOCODE_OUT_OF_SEASON: "API__EP__BILLING__PROMOCODE_OUT_OF_SEASON",
    PROMOCODE_PRODUCT_INCOMPATIBLE: "API__EP__BILLING__PROMOCODE_PRODUCT_INCOMPATIBLE",
    PROMOCODE_REDEEMED: "API__EP__BILLING__PROMOCODE_REDEEMED",
    PROMOCODE_REDEEMS_EXCEEDED: "API__EP__BILLING__PROMOCODE_REDEEMS_EXCEEDED",
    RECURRING_PAYMENT_FREE_PLAN_LOCKED: "API__EP__BILLING__RECURRING_PAYMENT_FREE_PLAN_LOCKED",
    RECURRING_PAYMENT_PLAN_LOCKED: "API__EP__BILLING__RECURRING_PAYMENT_PLAN_LOCKED",
    RECURRING_PAYMENT_TRIAL_PLAN_LOCKED: "API__EP__BILLING__RECURRING_PAYMENT_TRIAL_PLAN_LOCKED",
};
//# sourceMappingURL=promocode.static.js.map